<template>
  <div class="header-mobile">
    <div class="nav-bar">
      <slot name="wap-prev">
        <span class="menu-btn iconfont" @click="toggleDrawer">&#xe61e;</span>
      </slot>
      
      <span class="logo" @click="navigation('/')">
        <slot name="wap-logo">
          <img src="@/image/home/logo.png" alt="logo" />
        </slot>
      </span>
      <slot name="wap-next">
        <!-- <span class="iconfont search" @click="toggleSearch">&#xe604;</span> -->
        <span></span>
      </slot>
    </div>
    
    <div class="side-bar" :class="{open: drawerShow}" @click="toggleDrawer">
      <div class="side-drawer">
        <div v-if="false" class="user-box">
          <div class="image" @click="handleClickAvatar">
            <Avatar :src="avatarUrl"/>
          </div>
          <div class="user-info">
            <span class="login" @click="login" v-if="!user">登录/注册</span>
            <h6  @click="navigation(`/profile/${user.uid}`)" v-else>{{user.nick}}</h6>
          </div>
          <div class="setting" v-if="loginUser" @click="navigation('https://account.geekbang.org/dashboard')">
            <i class="iconfont">&#xe61c;</i>
          </div>
        </div>
        <div class="nav">
          <ul>
            <li @click="navigateTo('/')">首页</li>
            <li v-for="(item) in list" :key="item.alias" @click="navigateTo(item.link, 64)">{{item.name}}</li>
            
            <!-- <li @click="navigation('/themes')">专题</li>
            <li @click="navigation('/hotlist')">热点文章</li>
            <li @click="navigation('/minibooks')">迷你书</li>
            <li @click="navigation('/topics')">全部频道</li>
            <li @click="navigation('/official/account')">公众号矩阵</li> -->
            <!-- <li @click="handleLogout" v-if="user">
              <span>退出登录</span>
            </li> -->
          </ul>
          <!-- <div class="other-menu">
            <div class="row">
              <div class="menu-item" @click="navigation('/themes')">
                <div class="icon-wrap">
                  <i class="iconfont">&#xe619;</i>
                </div>
                <p>专题</p>
              </div>
              <div class="menu-item" @click="navigation('/hotlist')">
                <div class="icon-wrap">
                  <i class="iconfont">&#xe61b;</i>
                </div>
                <p>热点文章</p>
              </div>
              <div class="menu-item" @click="navigation('/minibooks')">
                <div class="icon-wrap">
                  <i class="iconfont">&#xe617;</i>
                </div>
                <p>迷你书</p>
              </div>    
            </div>
            <div class="row">
              <div class="menu-item" @click="navigation('/topics')">
                <div class="icon-wrap">
                  <i class="iconfont">&#xe618;</i>
                </div>
                <p>全部频道</p>
              </div>
              <div class="menu-item" @click="navigation('/official/account')">
                <div class="icon-wrap">
                  <i class="iconfont">&#xe616;</i>
                </div>
                <p>公众号矩阵</p>
              </div>
              <div class="menu-item">
                <div class="icon-wrap">
                  <i class="iconfont">&#xe641;</i>
                </div>
                <p>话题</p>
              </div>
            </div>
          </div> -->
        </div>
      </div>

    </div>
    <!-- <div class="search-wrap" :class="{open: searchShow}">
      <div class="cover" @click="toggleSearch"></div>
      <div class="search-box">
        <input 
          type="text" 
          class="search-input" 
          ref="searchInput"
          :class="{open: searchShow}" 
          v-model="searchKey" 
          placeholder="请输入您要搜索的关键词" 
          @keyup.enter="search"
        >
        <span class="iconfont search-icon" @click="search">&#xe604;</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import utils from '../../../utils'

import Avatar from '../../Avatar'
export default {
  name: 'layout-header-wap',
  components: {
    Avatar
  },
  props: {
    id: {
      type: [String, Number],
      default: 0
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    ad: {
      type: Array,
      default () {
        return []
      }
    },
    user: {
      type: [Object, undefined]
    }
  },
  data () {
    return {
      drawerShow: false,
      searchShow: false,
      searchKey: ''
    }
  },
  computed: {
    ...mapState({
      loginUser: 'loginUser'
    }),
    avatarUrl () {
      return this.loginUser && this.loginUser.avatar || ''
    },
    uid () {
      return this.$route.params.uid
    },
    isSelf () {
      return this.loginUser && this.loginUser.uid + '' === this.uid + ''
    }
  },
  created () {},
  methods: {
    ...mapActions([
      'logout'
    ]),
    toggleDrawer () {
      this.drawerShow = !this.drawerShow
      this.drawerShow ? utils.fixedBody.open() : utils.fixedBody.close()
    },
    toggleSearch () {
      this.searchShow = !this.searchShow
      if (!this.searchShow) {
        this.searchKey = ''
      }
      this.searchShow ? utils.fixedBody.open() : utils.fixedBody.close()
    },
    navigation (path) {
      // this.$router.push(path)
      window.open(path)
    },
    login () {
      window.ga && window.ga('send', 'event', `「注册/登录」按钮`, `导航`, `mobile ${this.$route.name}`)
      utils.login()
    },
    search () {
      if (!this.searchKey) return
      // utils.search(this.searchKey)
      window.location.href = `https://s.geekbang.org/search/c=0/k=${this.searchKey}/t=`
    },
    handleClickAvatar () {
      if (!this.loginUser) {
        utils.login()
      } else {
        this.navigation(`/profile/${this.loginUser.uid}`)
      }
    },
    handleLogout () {
      this.logout()
      if (this.isSelf) {
        window.location.href = '//www.infoq.cn'
      }
    },
    /**
     * 模拟锚点跳转
     *
     * @param  {string}  path   路径
     * @param  {string}  calibration   校准
     */
    navigateTo (path, calibration) {
      if (this.isOutlink(path)) {
        window.location.href = path
      } else if (path.indexOf('#') > -1) {
        this.$router.replace(path, () => {})
        this.$nextTick(() => {
          // window.scrollTo(0, document.querySelector(path.slice(1)).offsetTop - calibration)
          this.$scrollTo(path.slice(1), 500)
          // console.log(path.slice(1))
          // console.log(document.querySelector(path.slice(1)).offsetTop)
          // window.scrollTo(0, 555)
        })
      } else {
        this.$router.replace(path, () => {})
      }
    },
    isOutlink (url) {
      if (!url) return true
      return url.indexOf('http') === 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/common";
.header-mobile {
  width: 100%;
}
.nav-bar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  width: 100%; height: 45px;
  padding: 0 20px;
  border-bottom:1px solid $borderGray;
  

  & .menu-btn {
    @include lineFont(18, 300);
    color: $red;
    // position: relative;
    // display: inline-block;
    // width: 20px; height: 1px;
    // background: $blue;

    // &:before,
    // &:after {
    //   content: ' ';
    //   position: absolute; left: 0;
    //   display: block;
    //   width: 20px; height: 1px;
    //   background: $blue;
    // }

    // &:before {
    //   top: -7px;
    // }

    // &:after {
    //   bottom: -7px;
    // }
  }

  & .logo {
    display: inline-block;
    // width: 78px; height: 24px;
    width: 80px; // height: 24px;
    // background:url('../../../assets/img/logo.png') no-repeat;
    background-size: 78px auto;
    display: flex;
    align-items: center;
    margin-left: 15px;

    & img {
      width: 100%; height: 100%;
    }

  }

  & .search {
    display: inline-block;
    width: 20px; height: 20px;
    @include lineFont(20 , 400); 
    color: $blue;
  }
}

.side-bar {
  position: fixed; z-index: 100; top: 0; left: 0; right: 0; bottom: 0;
  overflow-y: auto;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  @extend %transition;
  transition-delay: 0.1s;
  opacity: 0;
  pointer-events: none;

  &.open {
    pointer-events: auto;
    opacity: 1;
    transition-delay: 0;

    & .side-drawer {
      left: 0;
      transition-delay: 0.1s;
    }
  }
  
  & .side-drawer {
    display: flex;
    flex-direction: column;
    position: absolute; top: 0; left: -100%;
    width: calc(100% - 94px); min-height: 100%;
    // overflow-y: auto;
    background: #ffffff;
    @extend %transition;
    will-change: left;

    & .user-box {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      height: 150px;
      padding: 0 20px;

      & .image {
        flex-shrink: 0;
        overflow: hidden;
        width: 48px; height: 48px;
        margin-right: 10px;
        border-radius: 50%;

        & img {
          width: 100%; height: 100%;
        }
      }
    }

    & .login {
      @include lineFont(18, 400);
    }

    & .user-info {
      & h6 {
        @include row(1);
        @include lineFont(18, 400);
        line-height: 22px;
        word-break: break-all;
      }

      & p {
        @include row(1);
        @extend %font12;
        line-height: 14px;
      }
    }

    & .setting {
      margin-left: 10px;
      & .iconfont {
        font-size: 19px;
        line-height: 19px;
      }
    }

    & .nav {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      flex-direction: column;

      & ul {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 100%;
      }

      & li {
        height: 55px;
        padding: 0 20px;
        background: #ffffff;
        @include lineFont(16, 400);
        line-height: 55px;
        // @extend %animateFontBlack;
        border-top: 1px solid $borderGray;
        cursor: pointer;

        &:last-child {
          border-bottom: 1px solid $borderGray;
        }

        // &:active {
        //   background:#F6F7F9;
        //   transition: none;
        // }

        // &:hover {
        //   a {
        //     color: $blue;
        //   }
        // }

        & a,
        & span {
          display: block;
          color: $black;
          // @extend %animateFontBlack;
        }

        &.dot {
          position: relative;
          @extend %center;
          width: 25px;
          text-align: center;

          & em {
            position: absolute; right: -6px; top: 0;
            width: 6px; height: 6px;
            background: $orange;
            border-radius: 6px;
          }

          & span,
          & span:before,
          & span:after {
            width: 3px; height: 3px;
            background: $black;
            border-radius: 3px;
          }

          & span {
            display: block;
            position: relative;
          }

          & span:before,
          & span:after {
            position: absolute; top: 0;
            content: ' ';
            display: block;
          }

          & span:before {
            left: -7px;
          }
          & span:after {
            right: -7px;
          }
        }
      }

      & .other-menu {
        display: flex;
        flex-direction: column;
        padding: 18px 0;

        & .row {
          display: flex;
          // justify-content: space-between;
          flex: 1;
          padding: 0 20px;
        }

        & .row:nth-child(2) {
          padding: 0 20px 0 18px; margin-top: 20px;
          justify-content: flex-start;

          & .menu-item:last-child {
            opacity: 0;
          }
        }

        & .row .menu-item:nth-child(2) {
          flex: 1;
        }

        & .menu-item {
          @extend %center;
          flex-direction: column;
          // width: 62px;

          & .icon-wrap {
            box-sizing: border-box;
            width: 45px; height: 45px;
            background: #f5f7f8;
            border-radius: 50%;
            text-align: center;
            line-height: 45px;
            color: #B8BBCE;

            & .iconfont {
              font-size: 20px;
            }
          }

          & p {
            margin-top: 10px;
            @include lineFont(12, 400);
            color: #5d6788;
          }
        }
      }
    }
  }
}

.search-wrap {
  position: fixed; z-index: 100; top: 0; left: 0; right: 0; bottom: 0;
  overflow-y: auto;
  @extend %transition;
  opacity: 0;
  pointer-events: none;
  transition-delay: 0.1s;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }

  & .cover {
    position: absolute; z-index: 100; top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  & .search-box {
    position: absolute; z-index: 200; top: 0; left: 0;
    width: 100%; height: 45px;
    background: #ffffff;

    & .search-input {
      position: absolute; top: 50%; right:48px;
      width: calc(100% - 68px);
      padding: 0 0 2px 10px;
      @include font(14, 400);
      border: none;
      border-bottom: 1px solid $borderGray;
      transform: translate(120%, -50%);
      @extend %transition;
      transition-duration: 0.4s;

      &.open {
        transform: translate(0%, -50%);
      }
    }

    & span {
      color: $gray;
    }
    & .search-icon {
      position: absolute; top: 50%; right: 0;
      padding-right: 20px;
      height: 44px;
      background: #ffffff;
      @include font(20, 400);
      color: $blue;
      line-height: 42px;
      transform: translateY(-50%);
    }
  }
}
</style>
